import { css } from '@emotion/react';
import Head from 'next/head';
import { ReactElement } from 'react';
import Content from '@/components/Content';
import HomeList from '@/components/HomeList';

const Page = () => {
  return (
    <>
      <Head>
        <title>ホーム</title>
      </Head>
      <Content>
        <Content.Header heading='ホーム'></Content.Header>
        <HomeList />
      </Content>
    </>
  );
};

Page.getLayout = (page: ReactElement) => {
  return (
    <div css={root}>
      <div css={container}>{page}</div>
    </div>
  );
};
const root = css`
  min-height: calc(100vh - 7.2rem);
  padding: 4rem 2.4rem 8rem;
  background: var(--color-background-light);
`;

const container = css`
  width: 120rem;
  margin-right: auto;
  margin-left: auto;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
`;

export default Page;
